import { useAtomValue } from 'jotai';

import { useGetUserPermissions } from '@/api/directory';
import { userInstanceAtom } from '@/atoms/userDetails';

/**
 * Whether the reader may start an evaluation on someone: they edit evaluations, over a team, over every
 * department, or as an administrator. False while the permissions load, so nothing offered is taken back.
 */
export const useCanStartEvaluations = (): boolean => {
    const { data: permissions } = useGetUserPermissions();
    // Whether the reader is an administrator is a fact about the session, not about the directory
    // entry of the person being looked up.
    const { isAdminUser } = useAtomValue(userInstanceAtom);

    if (!permissions) return false;

    const hasScope =
        isAdminUser ||
        permissions.canManageTeamPerformance ||
        permissions.canManageAllDepartmentsPerformance;

    return hasScope && permissions.canEditEvaluations;
};
